<template>
  <TransitionFromTop>
    <div :class="style.contactsQuestion">
      <FormEditComponent />
    </div>
  </TransitionFromTop>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import style from "./ContactsAnswer.module.scss";
import FormEditComponent from "@/page/quiz/editor/landingPage/components/questions/typeQuestions/ContactsAnswer/components/FormEditComponent/FormEditComponent.vue";
import TransitionFromTop from "@/dynamics/transitions/TransitionFromTop/TransitionFromTop.vue";

export default defineComponent({
  name: "ContactsAnswer",
  components: {
    FormEditComponent,
    TransitionFromTop
  },
  data() {
    return {
      style
    };
  },
  computed: {
    selectedVersion() {
      return this.$quizStore.getSelectedVersion;
    },
    mobileVersion() {
      return this.selectedVersion === "Мобильная";
    }
  }
});
</script>
